import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import GeneralSetting from "./views/generalSetting";
import Schedule from "./views/schedule";
import Gallery from "./views/gallery";
import { AuthLayout } from "./components/PrivateRoute";
import { ROUTES } from "./config/routes";
import "./App.css";
import DeviceSetting from "./views/deviceSetting";
import MainLayout from "./components/Layout/MainLayout";
import NotFound from "./views/NotFound";
import { AntdProvider } from "./providers";
import Home from "./views/home";
import Traps from "./views/traps";
import DevicePanel from "./views/devicePanel";
import "./index.css";
import ImageCatalog from "./views/ImageCatalog";

const App: React.FC = () => {
  return (
    <AntdProvider>
      <Router>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route element={<MainLayout />}>
              <Route path={ROUTES.home} element={<Home />} />
              {/* <Route path={ROUTES.devicePanel} element={<DevicePanel />} /> */}
              <Route path={ROUTES.traps_and_locations} element={<Traps />} />
              <Route path={ROUTES.admin} element={<DevicePanel />} />
              <Route path={ROUTES.settings} element={<GeneralSetting />} />
              <Route path={ROUTES.schedule} element={<Schedule />} />
              <Route path={ROUTES.gallery} element={<Gallery />} />
              <Route path={ROUTES.image_catalog} element={<ImageCatalog />} />
              <Route
                path={ROUTES.device_settings}
                element={<DeviceSetting />}
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AntdProvider>
  );
};

export default App;
